// Analytics stub — defines the approved event taxonomy for Cursor to connect
// to the approved analytics provider. Never pass personal form values,
// sensitive data or secrets in event properties.

export const EVENTS = {
  PRODUCT_PAGE_VIEW: "product_page_view",
  PRODUCT_CTA_CLICK: "product_cta_click",
  DEMO_FORM_START: "demo_form_start",
  DEMO_FORM_SUBMIT: "demo_form_submit",
  ENQUIRY_SUBMIT: "enquiry_submit",
  CHATBOT_START: "chatbot_start",
  CHATBOT_HANDOFF: "chatbot_handoff",
  ARTICLE_VIEW: "article_view",
};

export function trackEvent(name, properties = {}) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug(`[analytics:stub] ${name}`, properties);
  }
}
